<div class="skeleton m-0 absolute no-overflow shadow-box left-0">
  <div class="skeleton__list-div m-16">
    <div
      *ngFor="let item of items"
      class="flex align-items-center justify-content-center mb-16">
      <div
        *ngIf="element"
        item-start
        class="element radius-50 h-px-70 w-70px ml-0 my-8 mr-8"></div>
      <section class="w-100">
        <div class="element h-40px"></div>
        <div class="element mt-8 h-40px"></div>
      </section>
    </div>
  </div>
</div>
